export const possibleValuesToString = (possibleValues: string[]) =>
    possibleValues.map(value => `"${value}"`).join(', ');
